import { Component, Input, Signal, ViewEncapsulation, computed, signal } from '@angular/core';
import { Frequency } from '@vendasta/galaxy/frequency';
import { PriceSummary } from '../../item-pricing-table/item-pricing-table.interface';

@Component({
  selector: 'inventory-ui-price-summary-display',
  templateUrl: './price-summary-display.component.html',
  styleUrls: ['./price-summary-display.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PriceSummaryDisplayComponent {
  protected readonly Frequency = Frequency;
  @Input() priceTotal: Signal<PriceSummary> = signal({
    oneTime: 0,
    monthly: 0,
    yearly: 0,
    currency: '',
  });

  public oneTimeCost = computed(() => {
    const priceTotal = this.priceTotal();
    return priceTotal.oneTime;
  });

  public monthlyCost = computed(() => {
    const priceTotal = this.priceTotal();
    return priceTotal.monthly;
  });

  public yearlyCost = computed(() => {
    const priceTotal = this.priceTotal();
    return priceTotal.yearly;
  });

  public currency = computed(() => {
    const priceTotal = this.priceTotal();
    return priceTotal.currency;
  });
}
